export default __webpack_public_path__ + "static/media/blue_loader.49835737.gif";